export default __webpack_public_path__ + "static/gates-6ec4f5c596fa0faa0be3290eb05be718.jpg";